function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Speaker-(No-Sound)");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6,0L4,7H0.3a0.3,0.3,0,0,0-.3.3v9.4a0.3,0.3,0,0,0,.3.3H4l7.6,7a0.4,0.4,0,0,0,.4-0.4V0.4A0.4,0.4,0,0,0,11.6,0Zm9.28,12,2.83-2.83a1,1,0,1,0-1.41-1.41l-2.83,2.83L16.64,7.76a1,1,0,1,0-1.41,1.41L18.05,12l-2.83,2.83a1,1,0,0,0,1.41,1.41l2.83-2.83,2.83,2.83a1,1,0,0,0,1.41-1.41Z"
});

var SvgNoSound = function SvgNoSound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoSound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-sound.7ad4848a.svg";
export { ForwardRef as ReactComponent };